import { useState } from "react";
import { Form, Formik } from "formik";
import TextInput from "../UI/TextInput";
import { dateMax } from "../../models/utils";
import { object } from "yup";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import ProfileCheck from "../Profile/ProfileCheck";
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
import { handleAPIError } from "../../utils/index.jsx";
import Callout from "../UI/Callout";
import styles from "./CandidaterForm.module.css";

export default function CandidaterForm({ onSubmitted, profiles, propertyId }) {
  const axios = useAuthenticatedAxios();
  const [error, setError] = useState("");

  async function submitHandler(values) {
    const candidatProfiles = Array.from(checked).map((i) => profiles[i].id);
    try {
      await axios.post(`/biens/${propertyId}/candidat`, {
        debut: values.debut,
        profile_ids: candidatProfiles,
      });
      onSubmitted();
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  const [checked, setChecked] = useState(new Set());

  function checkHandler(pos) {
    setChecked((curChecked) => {
      const newChecked = new Set(curChecked);
      if (curChecked.has(pos)) {
        newChecked.delete(pos);
      } else {
        newChecked.add(pos);
      }
      return newChecked;
    });
  }

  return (
    <>
      <h3 className={"text-center"}>
        Dernière étape avant l'envoi de votre dossier !
      </h3>
      <Formik
        initialValues={{ debut: "" }}
        onSubmit={submitHandler}
        validationSchema={object({
          debut: dateMax().required(
            "Une date d'emménagement souhaitée est obligatoire",
          ),
        })}
      >
        <Form className={styles.form}>
          <TextInput
            type="date"
            name="debut"
            label="Quelle est la date d'emménagement souhaitée"
            mandatory
            marginForm=""
          />
          <p>
            Selectionnez les profils avec lesquels vous souhaitez candidater :
          </p>
          <div className={styles.profiles}>
            {profiles.length !== 0 ? (
              profiles.map((profile, pos) => (
                <div onClick={checkHandler.bind(null, pos)} key={pos}>
                  <ProfileCheck
                    profile={profile}
                    id_bien={propertyId}
                    checked={checked.has(pos)}
                    candidater={true}
                  />
                </div>
              ))
            ) : (
              <div>Aucun profile trouvé</div>
            )}
          </div>
          <div className={styles.actions}>
            <FormikSubmitButton disabled={checked.size < 1}>
              Envoyer ma candidature
            </FormikSubmitButton>
          </div>
          <Callout variant="danger">{error}</Callout>
        </Form>
      </Formik>
    </>
  );
}
